export const URL_UNLIMITED_ROUTE = 'unlimited';
export const URL_CAMPAIGNS_ROUTE = 'campaigns';
